import axios from 'axios'

import authenticationService from '@/services/authentication/authentication'

import { OpenAPI } from './client/requests'
import { attachAuthorizationHeaderInterceptor, refreshIdTokenInterceptor } from './middlewares'

OpenAPI.BASE = import.meta.env.VITE_API_URL
OpenAPI.HEADERS = {}

OpenAPI.TOKEN = async () => (await authenticationService.getAccessToken()) ?? ''

OpenAPI.interceptors.request.use(async config => {
  const updatedConfig = await attachAuthorizationHeaderInterceptor(config)

  OpenAPI.HEADERS = {
    ...OpenAPI.HEADERS,
    Authorization: updatedConfig.headers?.Authorization,
  }

  return updatedConfig
})

OpenAPI.interceptors.response.use(refreshIdTokenInterceptor)

export const getAxiosClient = () => {
  return axios.create({
    baseURL: OpenAPI.BASE,
    headers: { ...OpenAPI.HEADERS },
  })
}
